import Navbar from "../components/Navbar/Navbar";
import AddExperience from "../components/profile-forms/AddExperience";

const AddExperiencePage = () => {
    return ( 
        <>
        <Navbar/>
        <AddExperience/>
        </>
     );
}
 
export default AddExperiencePage;